import React, { useState } from 'react';
import './InactiveAccountNotice.css';

const InactiveAccountNotice = ({ onClose }) => {
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  
  const handleSendSupportEmail = () => {
    // Format email with mailto link
    const subject = 'Kontoreaktivierung';
    const body = `Hallo HiFiCouch.World-Team,

ich möchte hiermit mein Konto reaktivieren.

Meine E-Mail-Adresse: ${email}

Vielen Dank!`;

    // Open default email client
    window.location.href = `mailto:support@hificouch.world?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    setEmailSent(true);
    setMessage('Ihr E-Mail-Programm wurde geöffnet. Bitte senden Sie die E-Mail, um Ihren Account zu reaktivieren.');
  };

  return (
    <div className="inactive-account-container">
      <div className="inactive-account-content">
        <div className="inactive-header">
          <span className="material-symbols-outlined warning-icon">admin_panel_settings</span>
          <h2>Konto deaktiviert</h2>
        </div>
        
        <div className="inactive-message">
          <p>Ihr Konto wurde aufgrund von Inaktivität (keine Anmeldung in den letzten 90 Tagen) automatisch deaktiviert.</p>
          <p>Um Ihr Konto zu reaktivieren, senden Sie bitte eine E-Mail an <strong>support@hificouch.world</strong>.</p>
        </div>
        
        {!emailSent ? (
          <div className="support-email-form">
            <div className="form-group">
              <label htmlFor="contact-email">Ihre E-Mail-Adresse:</label>
              <input 
                type="email" 
                id="contact-email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ihre-email@beispiel.de"
                required
              />
            </div>
            
            <div className="inactive-actions">
              <button 
                onClick={handleSendSupportEmail} 
                className="send-support-email"
                disabled={!email}
              >
                <span className="material-symbols-outlined">mail</span>
                Support kontaktieren
              </button>
              
              <button onClick={onClose} className="close-notice">
                <span className="material-symbols-outlined">close</span>
                Schließen
              </button>
            </div>
          </div>
        ) : (
          <div className="email-sent-confirmation">
            <span className="material-symbols-outlined success-icon">check_circle</span>
            <p>{message}</p>
            <button onClick={onClose} className="close-notice">
              <span className="material-symbols-outlined">close</span>
              Schließen
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InactiveAccountNotice;